import ReactPaginate from 'react-paginate'

const Pagination = ({pageCount, onPageChange, forcePage, initialPage}) => {
    return <ReactPaginate
        className="flex justify-center items-center space-x-1 text-rand-100 text-sm font-medium"
        pageClassName="py-2"
        nextClassName="py-2"
        previousClassName="py-2"
        pageLinkClassName="w-8 h-8 flex items-center justify-center rounded hover:bg-gray-100 border"
        previousLinkClassName="w-16 h-8 flex items-center justify-center rounded hover:bg-gray-100 border"
        nextLinkClassName="w-16 h-8 flex items-center justify-center rounded hover:bg-gray-100 border"
        disabledClassName=""
        disabledLinkClassName="text-neutral-darker bg-gray-100 cursor-not-allowed"
        activeClassName=""
        activeLinkClassName="px-3 py-2 text-white bg-secondary-500 rounded-full hover:bg-secondary-500 hover:text-white hover:cursor-default border-none"
        previousLabel={'Prev'}
        nextLabel={'Next'}
        breakLabel={'...'}
        breakClassName="w-8 h-8 flex items-center justify-center"
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={onPageChange}
        initialPage={initialPage}
        forcePage={forcePage}
    />
  } 
  
  export default Pagination